<template>
  <vx-card class="mt-base mb-5" :title="activityTitle">
    <p class="mb-5">
      Resilience is a trait that is highly valued in any police force. Resilience relates to how
      well you can carry out your responsibilities even in stressful circumstances. Resilience is
      the trait that allows you to keep going even when times get tough.
    </p>
    <p class="mb-5">
      Without resilience, a police officer’s career will be extremely short. For this reason,
      applicants are often asked about their personal resilience during the panel interview. Watch
      the following video to find out more:
    </p>
    <div class="vx-row my-5 flex items-center justify-center">
      <div class="vx-col xl:w-1/2 lg:w-2/3 w-full my-5">
        <custom-video
          aria-label="Watch The Importance of Resilience Video"
          elem-id="video-btn-0"
          :video-image="videoTrigger1"
          :video-url="videos[1]"
        />
      </div>
    </div>

    <p class="mb-5">
      It’s clear that being resilient and demonstrating that resilience is an essential part of the
      selection process.
    </p>
    <p class="mb-5">
      In light of what you learned in the above video, can you think of a significant event in your
      life that challenged your resilience? Follow the approach below to complete the activity.
    </p>
    <p class="mb-5">
      Note: even if you feel you do not have a high level of resilience, do not worry, resilience is
      a strength that can be learned and developed.
    </p>
    <p class="mb-5">Approach to the Resilience Question:</p>
    <ol class="numbered-list">
      <li>
        Identify a significant event in your life that challenged your abilities to meet your
        responsibilities. This event could be in any aspect of life: personal health, work-related,
        family relationships, death of someone close to you, financial problems, etc.
      </li>
      <li>
        Identify the other daily responsibilities you also had to manage during that time e.g., exam
        pressures, family responsibilities, work commitments, etc.
      </li>
      <li>
        Identify the actions you took explicitly related to managing the issue and coping with the
        stress and pressures you were under.
      </li>
      <li>
        Describe a positive outcome or thing that came out of this situation as a result of you
        handling it the way you did.
      </li>
    </ol>
    <p class="mb-8 text-bold">
      Respond to the following prompts and record the details in the spaces provided below:
    </p>
    <div class="focusable-parent">
      <label
        >1. Significant Event:
        <textarea-block
          class="focus-visible-style"
          v-model="data.question1"
          :editable="isEditable"
        />
      </label>
    </div>
    <div class="focusable-parent">
      <label
        >2. Responsibilities at the Time:
        <textarea-block
          class="focus-visible-style"
          v-model="data.question2"
          :editable="isEditable"
        />
      </label>
    </div>
    <div class="focusable-parent">
      <label
        >3. Actions Taken:
        <textarea-block
          class="focus-visible-style"
          v-model="data.question3"
          :editable="isEditable"
        />
      </label>
    </div>
    <div class="focusable-parent">
      <label
        >4. Positive Outcome
        <textarea-block
          class="focus-visible-style"
          v-model="data.question4"
          :editable="isEditable"
        />
      </label>
    </div>
    <save-buttons :is-editable="isEditable" @save="save" />
  </vx-card>
</template>

<script>
import methods from '@/views/WorkExperiences/components/activity_js/methods';
import computed from '@/views/WorkExperiences/components/activity_js/computed';
import inject from '@/views/WorkExperiences/components/activity_js/inject';
import CustomVideo from '@/components/CustomVideo.vue';
export default {
  components: { CustomVideo },
  data() {
    return {
      videoTrigger1: require('@/assets/images/experiences/policing/resilience.jpg'),
      videos: {
        1: $vjeConfig.VUE_APP_VJE_PUBLIC_OBJECT_STORAGE_URL + '/content/policing/resilience.mp4',
      },
      login_type: localStorage.getItem('login_type'),
    };
  },
  methods: methods,
  computed: computed,
  inject: inject,
  mounted() {
    if (typeof this.uploaded_files !== 'undefined') {
      for (let i = 1; i <= Object.keys(this.uploaded_files).length; i++) {
        if (typeof this.data['uploaded_file_' + i] !== 'undefined') {
          this.uploaded_files['uploaded_file_' + i] = this.data['uploaded_file_' + i];
        }
      }
    }
  },
};
</script>
